import React from 'react'
import {Segment} from 'semantic-ui-react'

export default function ({children}) {
  return (
    <Segment>
      {children || 'No content found'}
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./src/components/empty/index.js